import idb from "@/plugins/indexdb.js";
import ColorsRepository from "../../repositories/settings/colors";

export default {
  namespaced: true,
  state: {
    colors: []
  },
  mutations: {
    // Set colors
    setColors(state, colors) {
      state.colors = colors;
    }
  },
  actions: {
    // Get all colors from api
    async getColors({ commit }) {
      try {
        const { data } = await ColorsRepository.get();
        commit("setColors", data);
      } catch (error) {
        throw error;
      }
    },

    // Gets colors by type
    async getColorsByType(context, color_type) {
      try {
        return await idb.db.colors.where({ type: color_type }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the transfer type colors in IndexedDB
    async getTransferType() {
      try {
        return await idb.db.colors.where({ type: "TRANSFER" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the xxl type colors in IndexedDB
    async getXXLType() {
      try {
        return await idb.db.colors.where({ type: "XXL" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the light type colors in IndexedDB
    async getLightType() {
      try {
        return await idb.db.colors.where({ type: "LIGHT" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the plama type colors in IndexedDB
    async getPalmaType() {
      try {
        return await idb.db.colors.where({ type: "PALMA" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Gets the seat type colors in IndexedDB
    async getSeatType() {
      try {
        return await idb.db.colors.where({ type: "SEAT" }).toArray();
      } catch (error) {
        throw error;
      }
    },

    // Clean colors
    clean({ commit }) {
      commit("setColors", []);
    }
  }
};
